module.exports = __webpack_public_path__ + "static/img/android.b2bff45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android.png
// module id = MZRY
// module chunks = 1